import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuthStore } from '../stores/auth'

interface ProtectedRouteProps {
  children: ReactNode
  /** If true, allow access even when mustChangePassword=true (used on /change-password). */
  allowMustChange?: boolean
}

export function ProtectedRoute({ children, allowMustChange = false }: ProtectedRouteProps) {
  const location = useLocation()
  const { user, initialized } = useAuthStore()

  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-b4l-text-muted">
        Se inițializează…
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (user.mustChangePassword && !allowMustChange) {
    return <Navigate to="/change-password" replace />
  }

  return <>{children}</>
}
